export { default as AuthSelector } from "./components/AuthSelector.vue.js";
